import { ConditionOptionsType } from '~/constants/automationRuleForm';
import { JSONAutomationRule } from '~/types/AutomationRule';
import AutomationRuleError from '~/types/AutomationRuleError';
import BusinessRule from '~/types/BusinessRule';
import { ParseBusinessRulesReturnType } from '~/utils/businessRules';
import { ActionKeys } from './constants';

export function fetchBusinessRules() {
  return <const>{
    type: ActionKeys.FETCH_BUSINESS_RULES,
  };
}

export function fetchBusinessRulesSuccess(payload: ParseBusinessRulesReturnType) {
  return <const>{
    payload,
    type: ActionKeys.FETCH_BUSINESS_RULES_SUCCESS,
  };
}

export function fetchBusinessRulesError(payload: { errorMessage: string }) {
  return <const>{
    payload,
    type: ActionKeys.FETCH_BUSINESS_RULES_ERROR,
  };
}

export function openDeleteModal() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_OPEN_DELETE_MODAL,
  };
}

export function closeDeleteModal() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_CLOSE_DELETE_MODAL,
  };
}

export function deleteRule(ruleId: string) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_DELETE_RULE,
    payload: {
      ruleId,
    },
  };
}

export function deleteRuleSuccess() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_DELETE_RULE_SUCCESS,
  };
}

export function deleteRuleError(errorMessage: string) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_DELETE_RULE_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export function openAddRuleModal() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_OPEN_ADD_RULE_MODAL,
  };
}

export function closeAddRuleModal() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_CLOSE_ADD_RULE_MODAL,
  };
}

export function changeSelectedFilterGroup(filterGroupId: number) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_CHANGE_SELECTED_FILTER_GROUP,
    payload: {
      filterGroupId,
    },
  };
}

export function changeSelectedUserParcelTemplate(userParcelTemplateObjectId: string) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_CHANGE_SELECTED_USER_PARCEL_TEMPLATE,
    payload: {
      userParcelTemplateObjectId,
    },
  };
}

export function createRule(ruleFormData: Maybe<JSONAutomationRule>) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_CREATE_RULE,
    payload: {
      ruleFormData,
    },
  };
}

export function createRuleSuccess() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_CREATE_RULE_SUCCESS,
  };
}

export function setRuleError(error: AutomationRuleError) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_SET_RULE_ERROR,
    payload: {
      error,
    },
  };
}

export function reorderRules(rules: BusinessRule[]) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_REORDER_RULES,
    payload: {
      rules,
    },
  };
}

export function reorderRulesSuccess(rules: BusinessRule[]) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_REORDER_RULES_SUCCESS,
    payload: {
      rules,
    },
  };
}

export function reorderRulesError(errorMessage: string) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_REORDER_RULES_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export function reprocessRules() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_REPROCESS_RULES,
  };
}

export function getRuleReprocessStatus() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_GET_REPROCESS_STATUS,
  };
}

export function startRuleReprocessStatusPolling() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_REPROCESS_RULES_POLL_START,
  };
}

export function stopRuleReprocessStatusPolling() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_REPROCESS_RULES_POLL_END,
  };
}

export function updateRuleReprocessStatus(status: string) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_UPDATE_REPROCESS_STATUS,
    payload: {
      status,
    },
  };
}

export function resetReprocessingPendingNotification() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_RESET_RULE_REPROCESS_PENDING_NOTIF,
  };
}

export function resetReprocessingCompleteNotification() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_RESET_RULE_REPROCESS_COMPLETE_NOTIF,
  };
}

export function closeReprocessingPendingNotification() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_CLOSE_RULE_REPROCESS_PENDING_NOTIF,
  };
}

export function closeReprocessingCompleteNotification() {
  return <const>{
    type: ActionKeys.AUTOMATIONS_CLOSE_RULE_REPROCESS_COMPLETE_NOTIF,
  };
}

export function updateDisabledConditionOptionsList(payload: ConditionOptionsType) {
  return <const>{
    type: ActionKeys.AUTOMATIONS_UPDATE_DISABLED_CONDITION_OPTIONS_LIST,
    payload,
  };
}

export type AutomationsActions =
  | ReturnType<typeof fetchBusinessRules>
  | ReturnType<typeof fetchBusinessRulesSuccess>
  | ReturnType<typeof fetchBusinessRulesError>
  | ReturnType<typeof openDeleteModal>
  | ReturnType<typeof closeDeleteModal>
  | ReturnType<typeof deleteRule>
  | ReturnType<typeof deleteRuleSuccess>
  | ReturnType<typeof deleteRuleError>
  | ReturnType<typeof openAddRuleModal>
  | ReturnType<typeof closeAddRuleModal>
  | ReturnType<typeof changeSelectedFilterGroup>
  | ReturnType<typeof changeSelectedUserParcelTemplate>
  | ReturnType<typeof createRule>
  | ReturnType<typeof createRuleSuccess>
  | ReturnType<typeof setRuleError>
  | ReturnType<typeof reorderRules>
  | ReturnType<typeof reorderRulesSuccess>
  | ReturnType<typeof reorderRulesError>
  | ReturnType<typeof reprocessRules>
  | ReturnType<typeof getRuleReprocessStatus>
  | ReturnType<typeof startRuleReprocessStatusPolling>
  | ReturnType<typeof stopRuleReprocessStatusPolling>
  | ReturnType<typeof updateRuleReprocessStatus>
  | ReturnType<typeof closeReprocessingPendingNotification>
  | ReturnType<typeof closeReprocessingCompleteNotification>
  | ReturnType<typeof resetReprocessingPendingNotification>
  | ReturnType<typeof resetReprocessingCompleteNotification>
  | ReturnType<typeof updateDisabledConditionOptionsList>;
